// animation-state.service.ts
import { Injectable, signal } from '@angular/core';

export type AnimationState = 'playing' | 'paused' | 'stopped';

@Injectable({
  providedIn: 'root',
})
export class AnimationStateService {
  public animationState = signal<AnimationState>('stopped');
  public currentSegmentIndex = 0;
  public currentCounter = 0;
}
